export default (pageInfos: any) => {
  let uri = '';
  (pageInfos.pageType === 'profile') && (uri = `/corpo/${pageInfos.slugname}/${pageInfos.slugnumber}`);
  (pageInfos.pageType === 'apply') && (uri = `/apply/${pageInfos.slugname}/${pageInfos.slugnumber}/${pageInfos.rank}`);
  return uri;
}